<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item label="仓库代码：" class="query-form-item">
                <el-input v-model="query.warehouse_code" placeholder="请输入海关编码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                <el-button type="primary" @click.native="handleForm(null,null)">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            stripe border style="width: 100%">
            <el-table-column
                label="ID"
                prop="id"
                align="center"
                width="80px">
            </el-table-column>
            <el-table-column label="国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                label="仓库代码"
                align="center"
                prop="warehouse_code"
                width="100px">
            </el-table-column>
            <el-table-column
                label="收件人"
                align="center"
                prop="consignee_people"
                width="130px">
            </el-table-column>
            <el-table-column
                label="收件公司"
                align="center"
                prop="consignee_company"
                width="200px">
            </el-table-column>
            <el-table-column
                label="收件国家"
                align="center"
                prop="consignee_state"
                width="100px">
            </el-table-column>
            <el-table-column
                label="收件城市"
                align="center"
                prop="consignee_city"
                width="100px">
            </el-table-column>
            <el-table-column
                label="收件地址"
                align="center"
                prop="consignee_address">
            </el-table-column>
            <el-table-column
                label="收件省州"
                align="center"
                prop="consignee_province"
                width="100px">
            </el-table-column>
            <el-table-column
                label="收件邮编"
                align="center"
                prop="consignee_postcode"
                width="100px">
            </el-table-column>
            <el-table-column
                label="收件电话"
                align="center"
                prop="consignee_phone"
                width="150px">
            </el-table-column>


            <el-table-column
                label="操作"
                width="150"
                align="center"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="success" size="mini" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.$index, scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            background
            :page-size="query.limit"
            style="float: right;margin-top: 20px; margin-bottom: 22px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="query.page"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog
            v-if="formVisible"
            :title="formMap[formName]"
            :visible.sync="formVisible"
            :before-close="hideForm"
            width="600px"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="100px">
                <el-form-item label="国家" prop="state">
                    <el-select v-model="formData.state" style="width: 150px;" size="mini" filterable :disabled="this.formName == 'edit'">
                        <el-option
                            v-for="item in $common.us_arr_normal"
                            :key="item.us"
                            :label="item.title"
                            :value="item.us"
                            :disabled="item.disabled">
                            <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us.toUpperCase()"
                                          style="font-size: 24px;margin-right:5px;"></icon-svg>
                                <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{item.title}}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="仓库代码">
                    <el-input v-model="formData.warehouse_code" placeholder="请输入仓库代码" auto-complete="off"
                              style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="收件人">
                    <el-input v-model="formData.consignee_people" class="" placeholder="请输入收件人" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="收件公司">
                    <el-input v-model="formData.consignee_company" placeholder="请输入收件公司" auto-complete="off"
                              style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="收件国家" prop="consignee_state">
                    <el-input v-model="formData.consignee_state" placeholder="请输入收件国家" auto-complete="off"
                              style="width: 300px;"></el-input>
                </el-form-item>
                <el-form-item label="收件城市">
                    <el-input v-model="formData.consignee_city" class="" placeholder="请输入收件城市" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="收件地址">
                    <el-input v-model="formData.consignee_address" class="" placeholder="请输入收件地址" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="收件省州">
                    <el-input v-model="formData.consignee_province" class="" placeholder="请输入收件省州" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
                <el-form-item label="收件邮编">
                    <el-input v-model="formData.consignee_postcode" class="" placeholder="请输入收件邮编" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>

                <el-form-item label="收件电话" prop="tel">
                    <el-input v-model="formData.consignee_phone" class="" placeholder="请输入收件电话" auto-complete="off"
                              style="width: 300px; "></el-input>
                </el-form-item>
            </el-form>


            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm" size="mini">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" size="mini">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {
        logistics_address_index,
        logistics_address_add,
        logistics_address_edit,
        logistics_address_deleted,
    } from '@/api/advAnalys/advAnalys.js'

    const formJson = {
        warehouse_code: '',
        consignee_people: '',
        consignee_company: '',
        state: '',
        consignee_state: '',
        consignee_city: '',
        consignee_address: '',
        consignee_province: '',
        consignee_postcode: '',
        consignee_phone: '',
    }
    export default {
        data() {
            let validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'))
                } else {
                    callback()
                }
            }
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'))
                } else if (value !== this.formData.password) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            }
            return {
                query: {
                    warehouse_code: '',
                    page: 1,
                    limit: 20,
                },
                list: [],
                total: 0,
                loading: true,
                index: null,
                formName: null,
                formMap: {
                    add: '新增发票地址',
                    edit: '编辑发票地址'
                },
                formLoading: false,
                formVisible: false,
                formData: formJson,
                formRules: {},
                addRules: {
                    state: [
                        {required: true, message: '请选择国家', trigger: 'blur'}
                    ],
                },
                editRules: {
                    username: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ],
                    status: [
                        {required: true, message: '请选择状态', trigger: 'change'}
                    ]
                },
                deleteLoading: false
            }
        },
        methods: {
            onReset() {
                this.$router.push({
                    path: ''
                })
                this.query = {
                    warehouse_code: '',
                    status: '',
                    page: 1,
                    limit: 20,
                    role_id: '',
                    total: 0
                }
                this.getList()
            },
            onSubmit() {
                this.query.page = 1
                this.getList()
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            getList() {
                this.loading = true
                logistics_address_index(this.query)
                    .then(response => {
                        this.loading = false
                        this.list = response.data.list || []
                        this.total = response.data.total || 0
                    })
                    .catch(() => {
                        this.loading = false
                        this.list = []
                        this.total = 0
                        this.roles = []
                    })
            },
            // 刷新表单
            resetForm() {
                if (this.$refs['dataForm']) {
                    // 清空验证信息表单
                    this.$refs['dataForm'].clearValidate()
                    // 刷新表单
                    this.$refs['dataForm'].resetFields()
                }
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible
                this.formData = JSON.parse(JSON.stringify(formJson))
                // 清空表单
                this.$refs['dataForm'].resetFields()
                return true
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true
                if (row !== null) {
                    this.formData = Object.assign({}, row)
                }
                this.formName = 'add'
                this.formRules = this.addRules
                if (index !== null) {
                    this.index = index
                    this.formName = 'edit'
                    this.formRules = this.editRules
                }
            },
            formSubmit() {
                this.$refs['dataForm'].validate(valid => {
                    if (valid) {
                        this.formLoading = true
                        let data = Object.assign({}, this.formData)
                        if (this.formName == 'add') {
                            logistics_address_add(data).then(response => {
                                if (response.code == 0) {
                                    this.hideForm()
                                    this.getList()
                                } else {
                                    this.$message.error(response.message)
                                }
                            }).catch(() => {
                                this.formLoading = false
                            }).finally(() => {
                                this.formLoading = false
                            })
                        } else {
                            data.id = this.formData.id
                            logistics_address_edit(data).then(response => {
                                if (response.code == 0) {
                                    this.hideForm()
                                    this.getList()
                                } else {
                                    this.$message.error(response.message)
                                }
                            }).catch(() => {
                                this.formLoading = false
                            }).finally(() => {
                                this.formLoading = false
                            })
                        }

                    }
                })
            },
            // 删除
            handleDel(index, row) {
                if (row.id) {
                    this.$confirm('确认删除该记录吗?', '提示', {
                        type: 'warning'
                    })
                        .then(() => {
                            let para = {id: row.id}
                            this.deleteLoading = true
                            logistics_address_deleted(para)
                                .then(response => {
                                    this.deleteLoading = false
                                    if (response.code) {
                                        this.$message.error(response.message)
                                        return false
                                    }
                                    this.$message.success('操作成功')
                                    // 刷新数据
                                    this.list.splice(index, 1)
                                })
                                .catch(() => {
                                    this.deleteLoading = false
                                })
                        })
                        .catch(() => {
                            this.$message.info('取消删除')
                        })
                }
            }
        },
        mounted() {
        },
        created() {
            this.getList()
        }
    }
</script>

<style type="text/scss" lang="scss">
</style>
